<template>
  <div class="cf-card cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16">
    <h2 class="cf-title cf-title--2 cf-text-align-center">
      Would you like to add a payment method?
    </h2>

    <button
      v-if="isCreditCardAddEnabled"
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="$openModal('addPaymentMethod')"
    >
      {{ paymentMethodsContent.addCreditCard }}
    </button>

    <button
      v-if="isGiftCardAddEnabled"
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      :disabled="hasReachedSavedCardLimit"
      @click="$openModal('giftCardAdd')"
    >
      {{ paymentMethodsContent.addGiftCard }}
    </button>

    <button
      v-if="isGiftCardAddEnabled"
      type="button"
      class="cf-button cf-button--primary cf-button--lg"
      :disabled="hasReachedSavedCardLimit"
      @click="$openModal('giftCardPurchase', { overrideReceiptNavigation: true })"
    >
      {{ paymentMethodsContent.purchaseGiftCard }}
    </button>

    <p
      v-if="hasReachedSavedCardLimit"
      class="cf-subtitle cf-subtitle--2"
    >
      {{ paymentMethodsContent.giftCardLimit }}
    </p>

    <!-- Add Card Modal -->
    <modal
      name="addPaymentMethod"
      modal-style="compact"
    >
      <cf-validated-form
        name="addPaymentMethod"
        :disabled="savedCards.isCreating"
        @valid-submit="addCardSubmitHandler"
      >
        <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
          <Teleport
            defer
            to="#portal-modal-header-target"
          >
            Card Details
          </Teleport>

          <cf-credit-card-form
            ref="cardInformation"
            :is-checkout-flow="false"
            :payment-gateway="merchant.defaultPaymentGateway"
            :require-billing-address="requireBillingAddress"
            @success="cardInformationSuccessHandler"
          />

          <button
            :class="['cf-button cf-button--primary cf-button--lg cf-button--fill', { 'cf-button--loading': savedCards.isCreating }]"
            type="submit"
          >
            Save Card
          </button>
        </div>
      </cf-validated-form>
    </modal>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';

  import CfCreditCardForm from '@/view/components/globals/cf-payment-methods/cf-credit-card-form/index.vue';


  export default {
    name: 'CfAddPaymentMethod',

    components: {
      CfValidatedForm,
      CfCreditCardForm
    },

    props: {
      isCreditCardAddEnabled: {
        type: Boolean,
        default: true
      },

      isGiftCardAddEnabled: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('savedCards', ['savedCards']),
      ...mapGetters('giftCards', ['hasReachedSavedCardLimit']),

      paymentMethodsContent() {
        const content = this.content.PayScreen.metadata;

        return {
          addCreditCard: content.addACreditCard,
          addGiftCard: content.addAGiftCard,
          purchaseGiftCard: content.purchaseAGiftCard,
          giftCardLimit: content.giftCardLimit
        };
      },

      requireBillingAddress() {
        const selectedLocationCreditCardMethod = this.selectedLocation.paymentGateway.methods.creditCard;

        return selectedLocationCreditCardMethod ? selectedLocationCreditCardMethod.requireFullBillingAddress
          : this.merchant.defaultPaymentGateway.methods.creditCard.requireFullBillingAddress;
      }
    },

    methods: {
      addCardSubmitHandler() {
        this.$refs.cardInformation.submit();

        // this.$triggerGoogleTrackingEvent('AddNewCreditCard', 'Account');

        this.$triggerNewRelicEvent('AddNewCreditCard', 'Information', 'Added New Credit Card');
      },

      async cardInformationSuccessHandler({ paymentMethod }) {
        const payload = {
          cardInformation: paymentMethod,
          isSilentNotifiction: false
        };

        await this.$store.dispatch('savedCards/createCard', payload);

        this.$closeModal('addPaymentMethod');
      }
    }
  };
</script>
